class NaptonModelSliders extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.sliders = [...this.querySelectorAll('[data-base-slider]')].map(slider => {
      const track = slider.querySelector('[data-model-track]');
      const previous = slider.querySelector('[data-model-prev]');
      const next = slider.querySelector('[data-model-next]');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const cards = [...track.querySelectorAll('[data-model-card]')];
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      slider.querySelector('.nms-controls').hidden = false;
      update();
      return { track, update };
    });
    this.addEventListener('change', event => {
      if (!event.target.matches('[data-model-boat]')) return;
      const link = event.target.closest('[data-model-card]').querySelector('[data-model-link]');
      link.href = event.target.value;
    }, { signal });
    this.resizeObserver = new ResizeObserver(() => this.sliders.forEach(slider => slider.update()));
    this.sliders.forEach(slider => this.resizeObserver.observe(slider.track));
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.resizeObserver?.disconnect();
  }
}
if (!customElements.get('napton-model-sliders')) customElements.define('napton-model-sliders', NaptonModelSliders);
